// extracted by mini-css-extract-plugin
export default {"redirection-link":"RedirectionLink_redirection-link__RV12U"};